import PropTypes from 'prop-types';
import React from 'react';
import Blocks from '../components/Blocks';
import Tiles from '../components/Tiles';
import styles from './subpage.module.css';

const SubPage = ({ blocks, references }) => {
  return (
    <div className={styles.wrapper}>
      {blocks.map((block, i) => <Blocks key={i} headerTag="h2" {...block} classNames={{ cards: styles.mdList, ...(block.classNames || {}) }} />)}
      {references && !!references.length && <Tiles entries={references} />}
    </div>
  );
};

SubPage.propTypes = {
  blocks: PropTypes.array.isRequired,
  references: PropTypes.array.isRequired,
};

export default SubPage;




// WEBPACK FOOTER //
// ./src/templates/subpage.js